/* MemoHol pilot – Oct 7 behaviour (homepage, Contact, Custom Studio). Loaded after theme.js, deferred.
   Everything decorative stops under prefers-reduced-motion. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const HEADER = 64;   // main bar height (FIX Oct 9 d)
  const scrollToEl = (el, smooth = true) => {
    if (!el) return;
    const top = el.getBoundingClientRect().top + window.scrollY - HEADER - 8;
    window.scrollTo({ top: Math.max(0, top), behavior: smooth && !reduceMotion.matches ? 'smooth' : 'auto' });
  };
  const relayout = () => window.dispatchEvent(new Event('resize'));

  /* ---------- Show / hide groups (Home core system + comparison, Contact comparison + application form) ----------
     [data-collapse="g"] panels start hidden. [data-collapse-open="g"] shows them (and hides [data-collapse-opener="g"]),
     [data-collapse-close="g"] hides them again and scrolls back, [data-collapse-toggle="g"] flips them.
     #apply in the URL (or a link to it) opens the "apply" group. */
  function initCollapse() {
    const panels = (g) => $$(`[data-collapse="${g}"]`);
    const set = (g, open, from) => {
      const ps = panels(g); if (!ps.length) return false;
      ps.forEach((p) => { p.hidden = !open; });
      $$(`[data-collapse-opener="${g}"]`).forEach((o) => { o.hidden = open; });
      $$(`[data-collapse-open="${g}"], [data-collapse-toggle="${g}"]`).forEach((b) => {
        b.setAttribute('aria-expanded', String(open));
        const lab = b.querySelector('[data-label-open]');
        if (lab) lab.textContent = open ? lab.dataset.labelOpen : lab.dataset.labelClosed;
      });
      relayout();
      requestAnimationFrame(() => {
        if (open) scrollToEl(ps[0]);
        else scrollToEl($(`[data-collapse-opener="${g}"]`) || (from && from.closest('section, .shopify-section')) || $(`[data-collapse-toggle="${g}"]`), true);
      });
      return true;
    };
    document.addEventListener('click', (e) => {
      const o = e.target.closest('[data-collapse-open]'), c = e.target.closest('[data-collapse-close]'), t = e.target.closest('[data-collapse-toggle]');
      if (o) { if (set(o.dataset.collapseOpen, true, o)) e.preventDefault(); }
      else if (c) { const g = c.dataset.collapseClose; set(g, false, c); if (g === 'apply' && location.hash === '#apply') history.replaceState(null, '', location.pathname + location.search); }
      else if (t) { const g = t.dataset.collapseToggle, ps = panels(g); set(g, !!(ps[0] && ps[0].hidden), t); }
    });
    const fromHash = () => { if (location.hash === '#apply') set('apply', true); };
    window.addEventListener('hashchange', fromHash);
    // #apply on load: open once the page has laid out (the browser's own jump fails while the form is hidden).
    if (location.hash === '#apply') requestAnimationFrame(() => setTimeout(fromHash, 60));
    else if (location.hash === '#partner') setTimeout(() => scrollToEl($('#partner'), false), 60);
  }

  /* ---------- Homepage paw trail: dog (#8A6500, big) and cat (#23704F, small) prints at 42% opacity weaving left/right to
     each [data-trail-stop] section top (Catmull–Rom curve), drawn into .paw-trail behind the content. ---------- */
  function initPawTrail() {
    const root = $('.home-paws'), layer = root && $('[data-paw-trail]', root); if (!root || !layer) return;
    let key = '', t = 0;
    const paw = (c) => '<svg viewBox="0 0 40 40" aria-hidden="true" focusable="false"><g fill="' + c + '"><ellipse cx="20" cy="27" rx="9" ry="7.5"/><circle cx="9" cy="16" r="4"/><circle cx="16" cy="9" r="4"/><circle cx="24" cy="9" r="4"/><circle cx="31" cy="16" r="4"/></g></svg>';
    const build = () => {
      root.classList.add('is-measuring');   // all positions as they'll be once revealed (no translate)
      const R = root.getBoundingClientRect(), W = R.width, H = root.scrollHeight;
      const rel = (el) => { const b = el.getBoundingClientRect(); return { l: b.left - R.left, t: b.top - R.top, r: b.right - R.left, b: b.bottom - R.top, w: b.width, h: b.height }; };
      const all = $$('[data-trail-stop]', root).filter((el) => el.offsetHeight > 0);
      const story = all.find((el) => el.hasAttribute('data-trail-story')), closing = $('[data-closing]', root), dog = closing && $('.mh-btn--dog img', closing);
      const stops = all.filter((el) => el !== story && el !== closing).map((el) => rel(el).t);
      const k = W + 'x' + H + ':' + stops.map(Math.round).join(',') + (dog ? ':' + Math.round(rel(dog).t) : ''); if (k === key) { root.classList.remove('is-measuring'); return; } key = k;
      if (stops.length < 2) { root.classList.remove('is-measuring'); layer.innerHTML = ''; return; }
      const sm = W < 720, s = sm ? .7 : 1, sideL = sm ? 22 : Math.max(60, W * .07), sideR = W - sideL, off = sm ? 24 : 48;
      const pts = stops.map((y, i) => ({ x: i % 2 ? sideL : sideR, y: y + off }));
      let flat = null;
      // Oct 9 (f): arrive on the right, cross the top padding of "09 Our story" right → left in a flat line (≥24px above
      // its heading), go down the left gutter, then curve to the closing section and end beside the dog-bone button
      // (phones with the button <60px from the edge: 16px above it). The closing section itself is not a stop.
      if (story && dog) {
        const st = rel(story), inner = $('.page-width', story) || story, cl = parseFloat(getComputedStyle(inner).paddingLeft) || 20;
        const head = $('h1, h2', story), ht = head ? rel(head).t : st.t + 80, reach = 47 * s;   // prints sit ≤ 47·s from the path
        const padTop = parseFloat(getComputedStyle(story).paddingTop) || 64;
        const y = Math.min(st.t + Math.max(padTop, ht - st.t) / 2, ht - 24 - reach);
        const gx = Math.max(16 * s, Math.min(sideL, (rel(inner).l + cl) / 2));
        const d = rel(dog), cs = rel(closing), side = d.l >= 60;
        const endX = side ? d.l - 8 - 18 * s : d.l + d.w / 2, endY = side ? d.t + d.h / 2 : d.t - 16 - 15 * s;
        pts.push({ x: sideR, y }); flat = { from: pts.length - 1, y };   // straight crossing from here to the gutter
        pts.push({ x: gx, y }, { x: gx, y: y + 120 }, { x: gx, y: Math.max(y + 160, cs.t) });
        pts.push(side ? { x: Math.max(gx, endX - 140 * s), y: endY } : { x: endX, y: endY - 90 * s }, { x: endX, y: endY });
      } else pts.push({ x: W / 2, y: H - 40 });
      const cr = (p0, p1, p2, p3, u) => { const u2 = u * u, u3 = u2 * u, f = (a, b, c, d) => .5 * (2 * b + (-a + c) * u + (2 * a - 5 * b + 4 * c - d) * u2 + (-a + 3 * b - 3 * c + d) * u3); return { x: f(p0.x, p1.x, p2.x, p3.x), y: f(p0.y, p1.y, p2.y, p3.y) }; };
      const dense = [];
      // Catmull–Rom through the points; the story-top crossing is a straight line (no dip under it), and the curves on either
      // side treat its ends as their own start / end so they meet it without overshoot.
      for (let i = 0; i < pts.length - 1; i++) {
        if (flat && i === flat.from) { const a = pts[i], b = pts[i + 1], n2 = Math.max(2, Math.round(Math.abs(a.x - b.x) / 6)); for (let j = 0; j < n2; j++) dense.push({ x: a.x + (b.x - a.x) * j / n2, y: flat.y }); continue; }
        const cut = flat ? flat.from : -1;
        const p0 = (i === cut + 1) ? pts[i] : (pts[i - 1] || pts[i]), p3 = (i + 1 === cut) ? pts[i + 1] : (pts[i + 2] || pts[i + 1]);
        for (let j = 0; j < 40; j++) dense.push(cr(p0, pts[i], pts[i + 1], p3, j / 40));
      }
      dense.push(pts[pts.length - 1]);
      // Never over text: line boxes of every text node (plus the buttons' live labels); prints touching one are skipped.
      const txt = [];
      const tw = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, { acceptNode: (n) => (n.textContent.trim() && !n.parentElement.closest('[data-paw-trail], script, style, [hidden], [aria-hidden="true"]:not(.mh-btn__text)')) ? 1 : 3 });
      // Text on the floating Tested-picks cards moves ±12px – give it extra room.
      let n; while ((n = tw.nextNode())) { const fl = n.parentElement.closest('.tests__card') ? 16 : 4, rg = document.createRange(); rg.selectNodeContents(n); for (const b of rg.getClientRects()) if (b.width > 1 && b.height > 1) txt.push({ l: b.left - R.left - 4, t: b.top - R.top - fl, r: b.right - R.left + 4, b: b.bottom - R.top + fl }); }
      root.classList.remove('is-measuring');
      if (dog) { const d = rel(dog); txt.push({ l: d.l - 8, t: d.t - 8, r: d.r + 8, b: d.b + 8 }); }
      if (closing) closing.querySelectorAll('.pk__svg').forEach((p) => { const d = rel(p); txt.push({ l: d.l - 6, t: d.t - 6, r: d.r + 6, b: d.b + 6 }); });   // Oct 9 (i): no prints on the pumpkins   // keep off the dog-bone button
      const hitsText = (x, y, z) => txt.some((b) => x + z / 2 > b.l && x - z / 2 < b.r && y + z / 2 > b.t && y - z / 2 < b.b);
      const out = [];
      const walk = (step, size, col, offN, shift) => {
        let acc = shift, i = 0;
        for (let k2 = 1; k2 < dense.length; k2++) {
          const a = dense[k2 - 1], b = dense[k2], dx = b.x - a.x, dy = b.y - a.y, d = Math.hypot(dx, dy); if (!d) continue;
          acc += d; if (acc < step) continue; acc = 0; i++;
          const nx = -dy / d, ny = dx / d, side = i % 2 ? 1 : -1, ang = Math.atan2(dy, dx) * 180 / Math.PI + 90;
          let x = b.x + nx * (offN + side * size * .45); const y = b.y + ny * (offN + side * size * .45);
          x = Math.min(Math.max(x, size / 2 + 2), W - size / 2 - 2);   // fully on screen
          if (hitsText(x, y, size)) continue;
          out.push('<div style="left:' + (x - size / 2).toFixed(1) + 'px;top:' + (y - size / 2).toFixed(1) + 'px;width:' + size + 'px;height:' + size + 'px;transform:rotate(' + ang.toFixed(0) + 'deg)">' + paw(col) + '</div>');
        }
      };
      walk(64 * s, 30 * s, '#8A6500', -18 * s, 0);
      walk(48 * s, 21 * s, '#23704F', 18 * s, 20 * s);
      // Finish exactly at the end point (beside / 16px above the dog-bone button) – the regular step can stop up to one stride short.
      if (story && dog) { const e = dense[dense.length - 1], p = dense[dense.length - 6] || e, z = 30 * s, ang = Math.atan2(e.y - p.y, e.x - p.x) * 180 / Math.PI + 90;
        if (!hitsText(e.x, e.y, z)) out.push('<div style="left:' + (e.x - z / 2).toFixed(1) + 'px;top:' + (e.y - z / 2).toFixed(1) + 'px;width:' + z + 'px;height:' + z + 'px;transform:rotate(' + ang.toFixed(0) + 'deg)">' + paw('#8A6500') + '</div>'); }
      layer.innerHTML = out.join('');
    };
    const queue = () => { clearTimeout(t); t = setTimeout(build, 150); };
    window.addEventListener('resize', queue);
    window.addEventListener('load', queue);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(queue);
    if ('ResizeObserver' in window) new ResizeObserver(queue).observe(root);
    queue();
  }

  /* ---------- Tested picks carousel: one card at a time, arrows, dots, swipe (40px), loops. ---------- */
  function initTests() {
    $$('[data-tests]').forEach((sec) => {
      const track = $('[data-tests-track]', sec), slides = $$('[data-tests-slide]', sec), dots = $$('[data-tests-dot]', sec);
      const n = slides.length; if (!track || n < 1) return;
      let i = 0;
      const go = (k) => {
        i = (k + n) % n;
        track.style.transform = `translateX(${-i * 100}%)`;
        slides.forEach((s, j) => { const on = j === i; s.toggleAttribute('inert', !on); s.setAttribute('aria-hidden', String(!on)); });
        dots.forEach((d, j) => d.setAttribute('aria-current', String(j === i)));
      };
      $('[data-tests-prev]', sec)?.addEventListener('click', () => go(i - 1));
      $('[data-tests-next]', sec)?.addEventListener('click', () => go(i + 1));
      dots.forEach((d) => d.addEventListener('click', () => go(+d.dataset.testsDot)));
      const vp = $('[data-tests-viewport]', sec); let sx = null, sy = 0;
      vp.addEventListener('touchstart', (e) => { const t = e.touches[0]; sx = t.clientX; sy = t.clientY; }, { passive: true });
      vp.addEventListener('touchend', (e) => {
        if (sx == null) return; const t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy; sx = null;
        if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy)) go(i + (dx < 0 ? 1 : -1));
      }, { passive: true });
      sec.addEventListener('keydown', (e) => { if (e.key === 'ArrowLeft') go(i - 1); else if (e.key === 'ArrowRight') go(i + 1); });
      go(0);
    });
  }

  /* ---------- Pick your pet: tabs, rotating photo (first ≤5 products, 4s), thumbnails. ---------- */
  function initPetPicker() {
    $$('[data-pets]').forEach((sec) => {
      const tabs = $$('[data-pet-tab]', sec), panels = $$('[data-pet-panel]', sec);
      let visible = false, hidden = document.hidden;
      const state = new Map();
      panels.forEach((p) => {
        const imgs = $$('[data-pet-slide]', p), hero = $('[data-pet-hero]', p), thumbs = $$('[data-pet-thumb]', p);
        const st = { p, imgs, hero, thumbs, idx: 0, hold: false, pickT: 0 };
        state.set(p.dataset.petPanel, st);
        if (imgs.length) $('.pets__frame', p)?.classList.add('is-rotating');
        const show = (k) => {
          if (!imgs.length) return;
          st.idx = (k + imgs.length) % imgs.length;
          imgs.forEach((im, j) => { im.classList.toggle('is-on', j === st.idx); if (j === st.idx) im.loading = 'eager'; });
          const cur = imgs[st.idx];
          if (hero && cur) { hero.href = cur.dataset.url; const nm = $('[data-pet-name]', hero), pr = $('[data-pet-price]', hero); if (nm) nm.textContent = cur.dataset.name; if (pr) pr.textContent = cur.dataset.price; }
          thumbs.forEach((t) => t.setAttribute('aria-current', String(t.dataset.petThumb !== '' && +t.dataset.petThumb === st.idx)));
        };
        st.show = show;
        thumbs.forEach((t) => t.addEventListener('click', () => {
          if (t.dataset.petThumb === '') { if (t.dataset.url) location.href = t.dataset.url; return; }
          st.pickT = Date.now(); show(+t.dataset.petThumb);
        }));
        if (hero) {
          ['pointerenter', 'focusin'].forEach((ev) => hero.addEventListener(ev, () => { st.hold = true; }));
          ['pointerleave', 'focusout'].forEach((ev) => hero.addEventListener(ev, () => { st.hold = false; }));
        }
        show(0);
      });
      const select = (id, focus) => {
        tabs.forEach((t) => { const on = t.dataset.petTab === id; t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1; if (on && focus) t.focus(); });
        panels.forEach((p) => { p.hidden = p.dataset.petPanel !== id; });
        const st = state.get(id); if (st) st.show(0);
      };
      tabs.forEach((t, k) => {
        t.addEventListener('click', () => select(t.dataset.petTab));
        t.addEventListener('keydown', (e) => {
          const d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (!d) return;
          e.preventDefault(); select(tabs[(k + d + tabs.length) % tabs.length].dataset.petTab, true);
        });
      });
      if ('IntersectionObserver' in window) new IntersectionObserver((es) => { visible = es[0].isIntersecting; }, { threshold: .35 }).observe(sec);
      else visible = true;
      document.addEventListener('visibilitychange', () => { hidden = document.hidden; });
      setInterval(() => {
        if (reduceMotion.matches || !visible || hidden) return;
        const cur = panels.find((p) => !p.hidden); const st = cur && state.get(cur.dataset.petPanel);
        if (!st || st.hold || st.imgs.length < 2 || Date.now() - st.pickT < 8000) return;
        st.show(st.idx + 1);
      }, 4000);
    });
  }

  /* ---------- Play and Display: 4 soap bubbles orbiting (1 turn / 90s; phones a tall oval, sides scaled .82–1);
     a click pops a bubble (swell + fade, rim flash, 26 droplets with gravity), it regrows after 1.1s. ---------- */
  function initPlay() {
    $$('[data-play]').forEach((ring) => {
      const spots = $$('[data-play-spot]', ring); if (!spots.length) return;
      const phone = window.matchMedia('(max-width: 719px)'), big = window.matchMedia('(min-width: 1400px)');
      let rot = 0, last = 0, raf = 0, visible = false;
      const place = () => {
        const oval = phone.matches, rx = oval ? 40 : big.matches ? 38 : 40, ry = oval ? 43 : big.matches ? 35.5 : 40;
        spots.forEach((el, i) => {
          const a = (-90 + i * 360 / spots.length + rot) * Math.PI / 180;
          el.style.left = (50 + rx * Math.cos(a)).toFixed(3) + '%';
          el.style.top = (50 + ry * Math.sin(a)).toFixed(3) + '%';
          el.style.transform = `translate(-50%, -50%)${oval ? ` scale(${(0.82 + 0.18 * Math.abs(Math.sin(a))).toFixed(3)})` : ''}`;
        });
      };
      const loop = (t) => {
        raf = 0;
        if (!visible || reduceMotion.matches || document.hidden) { last = 0; return; }
        raf = requestAnimationFrame(loop);
        rot = (rot + (last ? Math.min(64, t - last) : 0) * 360 / 90000) % 360; last = t;
        place();
      };
      const kick = () => { if (!raf) raf = requestAnimationFrame(loop); };
      ring.classList.add('is-js'); place();
      if ('IntersectionObserver' in window) new IntersectionObserver((es) => { visible = es[0].isIntersecting; if (visible) kick(); }).observe(ring);
      else { visible = true; kick(); }
      document.addEventListener('visibilitychange', kick);
      phone.addEventListener?.('change', place); big.addEventListener?.('change', place);
      reduceMotion.addEventListener?.('change', () => { place(); kick(); });

      const pop = (el) => {
        if (el._popping) return; el._popping = true;
        const host = el.parentNode;
        if (reduceMotion.matches || !el.animate) {
          el.style.opacity = '0'; setTimeout(() => { el.style.opacity = ''; el._popping = false; }, 900); return;
        }
        el.animate([{ transform: 'scale(1)', opacity: 1 }, { transform: 'scale(1.18)', opacity: .9, offset: .55 }, { transform: 'scale(1.3)', opacity: 0 }], { duration: 240, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'forwards' });
        const flash = document.createElement('span'); flash.className = 'play__flash'; flash.setAttribute('aria-hidden', 'true'); host.appendChild(flash);
        flash.animate([{ transform: 'scale(1)', opacity: .95 }, { transform: 'scale(1.35)', opacity: 0 }], { duration: 300, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'forwards' }).onfinish = () => flash.remove();
        const R = el.getBoundingClientRect().width / 2 / (parseFloat(getComputedStyle(host).scale) || 1);
        for (let i = 0; i < 26; i++) {
          const d = document.createElement('span'), ang = Math.random() * Math.PI * 2, sz = 2 + Math.pow(Math.random(), 2) * 6;
          const r0 = R * (.75 + Math.random() * .2), x0 = Math.cos(ang) * r0, y0 = Math.sin(ang) * r0;
          const fly = 18 + Math.random() * 46, x1 = Math.cos(ang) * (r0 + fly), y1 = Math.sin(ang) * (r0 + fly) - 6 * Math.random();
          const x2 = Math.cos(ang) * (r0 + fly * 1.35), y2 = y1 + 28 + Math.random() * 40, dur = 650 + Math.random() * 450;
          d.className = 'play__drop'; d.setAttribute('aria-hidden', 'true');
          d.style.cssText = `width:${sz.toFixed(1)}px;height:${(sz * 1.08).toFixed(1)}px;margin:${(-sz / 2).toFixed(1)}px 0 0 ${(-sz / 2).toFixed(1)}px;`;
          host.appendChild(d);
          d.animate([
            { transform: `translate(${x0.toFixed(1)}px,${y0.toFixed(1)}px) scale(.6)`, opacity: 0 },
            { transform: `translate(${x0.toFixed(1)}px,${y0.toFixed(1)}px) scale(1)`, opacity: 1, offset: .04 },
            { transform: `translate(${x1.toFixed(1)}px,${y1.toFixed(1)}px) scale(1)`, opacity: 1, offset: .38, easing: 'cubic-bezier(.3,0,.7,1)' },
            { transform: `translate(${x2.toFixed(1)}px,${y2.toFixed(1)}px) scale(.85)`, opacity: 0 }
          ], { duration: dur, easing: 'cubic-bezier(.15,.6,.3,1)', fill: 'forwards' }).onfinish = () => d.remove();
        }
        setTimeout(() => {
          el.animate([{ transform: 'scale(0)', opacity: 0 }, { transform: 'scale(1.08)', opacity: 1, offset: .65 }, { transform: 'scale(.97)', offset: .85 }, { transform: 'scale(1)', opacity: 1 }], { duration: 700, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'forwards' }).onfinish = () => { el._popping = false; };
        }, 1100);
      };
      ring.addEventListener('click', (e) => { const b = e.target.closest('[data-play-bub]'); if (b) pop(b); });
    });
  }

  /* ---------- Custom Studio: 4 steps, photo uploads (one file per line-item property), summary, Add to cart gate. ---------- */
  function initStudio() {
    $$('[data-sflow]').forEach((sec) => {
      const form = $('[data-studio-form]', sec), steps = $$('[data-step-go]', sec), panels = $$('[data-step]', sec);
      const back = $('[data-studio-back]', sec), next = $('[data-studio-next]', sec), add = $('[data-studio-add]', sec), pilot = $('[data-studio-pilot]', sec);
      const i18n = $('[data-studio-i18n]', sec).dataset, canOrder = sec.dataset.canOrder === 'true';
      const files = $('[data-studio-files]', sec), thumbs = $('[data-studio-thumbs]', sec), empty = $('[data-studio-empty]', sec), more = $('[data-studio-more]', sec);
      let step = 0, nPhotos = 0;
      const go = (k) => {
        step = Math.max(0, Math.min(panels.length - 1, k));
        panels.forEach((p) => { p.hidden = +p.dataset.step !== step; });
        steps.forEach((b, j) => { b.classList.toggle('is-done', j < step); if (j === step) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current'); });
        back.hidden = step === 0; next.hidden = step === panels.length - 1;
        if (sec.getBoundingClientRect().top < 0) scrollToEl(sec);
      };
      steps.forEach((b) => b.addEventListener('click', () => go(+b.dataset.stepGo)));
      back.addEventListener('click', () => go(step - 1));
      next.addEventListener('click', () => go(step + 1));

      // Photos: each pick is moved into the form as "Photo N" (Shopify takes one file per property); max 8.
      const wire = (input) => input.addEventListener('change', () => {
        const f = input.files && input.files[0];
        if (!f || !/^image\//.test(f.type) || nPhotos >= 8) { input.value = ''; return; }
        nPhotos++;
        const fresh = input.cloneNode(); fresh.value = ''; input.after(fresh); wire(fresh);
        input.name = `properties[Photo ${nPhotos}]`; input.removeAttribute('data-studio-file'); files.appendChild(input);
        const sw = document.createElement('span'); sw.setAttribute('role', 'img'); sw.setAttribute('aria-label', f.name); sw.style.backgroundImage = `url("${URL.createObjectURL(f)}")`; thumbs.appendChild(sw);
        empty.hidden = true; thumbs.hidden = false; more.hidden = nPhotos >= 8;
        update();
      });
      wire($('[data-studio-file]', sec));

      // Single piece / Gift box
      const modes = $$('[data-studio-mode]', sec), panes = $$('[data-studio-pane]', sec);
      modes.forEach((m) => m.addEventListener('click', () => {
        modes.forEach((x) => x.setAttribute('aria-selected', String(x === m)));
        panes.forEach((p) => { p.hidden = p.dataset.studioPane !== m.dataset.studioMode; });
        $$('[data-studio-piece]', sec).forEach((r) => { r.checked = false; });
        update();
      }));

      const setSum = (k, v) => { const dd = $(`[data-sum="${k}"]`, sec); if (!dd) return; dd.textContent = v || i18n.none; dd.classList.toggle('is-none', !v); };
      const update = () => {
        const name = ($('[data-studio-name]', sec).value || '').trim();
        const style = $('[data-studio-style]:checked', sec), piece = $('[data-studio-piece]:checked', sec);
        setSum('photos', nPhotos ? (nPhotos === 1 ? i18n.photoOne : i18n.photoMany.replace('{n}', nPhotos)) : '');
        setSum('name', name); setSum('style', style ? style.value : ''); setSum('piece', piece ? (piece.dataset.label || piece.value) : '');
        $('[data-sum="price"]', sec).textContent = piece ? piece.dataset.price : '—';
        add.disabled = !(nPhotos > 0 && name && style && piece);
        if (add.disabled) pilot.hidden = true;
      };
      form.addEventListener('input', update); form.addEventListener('change', update);
      form.addEventListener('submit', (e) => {
        if (add.disabled) { e.preventDefault(); return; }
        if (!canOrder) { e.preventDefault(); pilot.hidden = false; }   // pilot: no product connected → no order
      });
      go(0); update();
    });
  }

  const start = () => { initCollapse(); initPawTrail(); initTests(); initPetPicker(); initPlay(); initStudio(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
